<template>
    <div>
        <div class="form-item">
            <label class="label"><i class="required">*</i>产品品牌认证：</label>
        </div>
        <div class="form-item" v-for="(sItem,sIndex) in secondProductList" :key="sItem.ProductId">
            <label class="label">{{sItem.ProductName}}</label>
            <div class="input-box">
                <template v-if="allTag[sIndex]">
                    <div class="tag-item" v-for="(tItem,tIndex) in allTag[sIndex]" :key="tIndex">
                        {{tItem.chooseText}}
                        <i class="el-icon el-icon-close" @click="removeThreeProductList(sIndex, tIndex)"></i>
                    </div>
                </template>
                <div class="btn-add" @click="showThreeProductList(sIndex)">
                <i class="el-icon el-icon-plus"></i>
                添加
                </div>
            </div>
        </div>
        <my-dialog class="stages-dialog" :show="showStep" titleCenter title="工程师产品 - 品牌认证" @close="showStep=false;">
            <!-- 三级产品 -->
            <block v-if="showStep === 1">
              <ul class="domain-wrapper" >
                  <label class="d-block" v-for="item in threeProductList" :key="'ProductId'+item.ProductId">
                      <input class="radio" type="radio" name="domain" v-model="threeProductChecked" :value="item" />
                      <span class="radio-val">{{item.ProductName}}</span>
                  </label>
              </ul>
              <div class="btn-primary"  @click="confirmThreeProduct">确认</div>
            </block>
            <div class="check-wrapper" v-if="showStep === 2">
              <i class="icon-back" @click="showStep=1"></i>
              <div class="search-wrapper">
                <div class="search-box">
                  <input type="text" v-model="brandName" autocomplete="false" placeholder="输入您想要搜索的品牌" @keydown.enter="searchBrand">
                  <i class="icon-search">
                    <svg class="icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1312"><path d="M954.572 922.815l-167.229-180.474c71.167-76.249 114.775-178.533 114.775-290.814 0-235.209-191.361-426.563-426.563-426.563-235.209 0-426.563 191.355-426.563 426.563s191.355 426.563 426.563 426.563c93.821 0 180.667-30.449 251.172-81.984l168.429 181.771c7.977 8.617 18.829 12.975 29.721 12.975 9.85 0 19.725-3.573 27.519-10.791 16.402-15.21 17.391-40.836 2.175-57.245zM130.004 451.526c0-190.537 155.015-345.551 345.551-345.551 190.543 0 345.551 155.015 345.551 345.551s-155.007 345.552-345.551 345.552c-190.537 0-345.551-155.015-345.551-345.552z" p-id="1313"></path></svg>
                  </i>
                </div>
                <button class="btn-text" @click="searchBrand">搜索</button>
                <button class="btn-check-all" v-if="!isCheckAll" @click="checkAll">全选</button>
                <button class="btn-check-all" v-if="isCheckAll" @click="checkAllFalse">取消全选</button>
              </div>
              <ul class="letter-list">
                <li v-for="(item,index) in letters" :class="{on:letterKey==item}" :key="index" @click="filterBrand(item)">{{item?item:'全部'}}</li>
              </ul>
              <ul class="check-list">
                <li v-for="item in filterBrandList" :key="item.BrandId">
                  <label class="check-item">
                    <input class="checkbox" ref="checkbox" type="checkbox" name="brand" v-model="brandChecked" :value="item" />
                    <span class="text">{{item.BrandName}}</span>
                  </label>
                </li>
              </ul>
              <div class="btn-primary" @click="confirmBrand">确认</div>
          </div>
        </my-dialog>
    </div>
</template>
<script>
import Dialog from "@/components/gkDialog.vue";
import { 
  ThreeProductList,
  ProductBrands,
} from '@/scripts/api.js'
import {mapState} from 'vuex'


export default({
    components: {
    "my-dialog": Dialog,
  },
    props: {
        ll: {
            type: Boolean,
            value: false
        },
        allTag: {
          type: Array,
          value: []
        }
    },
    computed: {
    ...mapState({
      secondProductList: state => state.secondProductList,
    })
  },
    data() {
        return {
            threeProductChecked: "",
            threeProductList: [],
            showThreeProductStageDialog: false,
            activeIndex1: null,
            activeIndex2: null,
            showStep: null,
            brandChecked: [],
            stagesAuth: [],
            // allTag: [], // 服务类型认证
            brandList: [],
            filterBrandList: [],
            brandName: "",
            letterKey: "",
            isCheckAll: false,
            letters:['','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
        }
    },
    methods: {
        // 新增二级产品、三级产品逻辑 开始
        getThreeProductList(item, index) {
            ThreeProductList({ParentId: item.ProductId}).then(r=>{
                if(r.Result==1){
                    this.threeProductList = r.Data.ProductList;
                    this.secondProductList[index].allThree = r.Data.ProductList;
                    console.log("this.threeProductList",this.threeProductList)
                    console.log("this.secondProductList",this.secondProductList)
                    console.log("this.showThreeProductStageDialog",this.showThreeProductStageDialog)
                }
            })
        },
        removeThreeProductList(sIndex, tIndex){
            let newList = this.allTag[sIndex];
            newList.splice(tIndex,1);
            this.allTag[sIndex] = newList;
            this.onSelectPB();
            this.$forceUpdate();
            console.log("allTag",this.allTag)
        },
        resetDialog() {
            this.threeProductChecked = "";
            this.brandChecked = [];
        },
        showThreeProductList(index) {
            this.resetDialog();
            console.log("this.secondProductList",this.secondProductList, "index", index);
            // 接口请求过得话，不用二次请求
            if(this.secondProductList[index].allThree) {
                this.threeProductList = this.secondProductList[index].threeProductList || this.secondProductList[index].allThree;
            }else {
                this.getThreeProductList(this.secondProductList[index], index);
            }
            this.showThreeProductStageDialog = true;
            this.showStep = 1;
            this.activeIndex1 = index;
            this.showThreeProductStageDialogStep = 1;
        },
        confirmThreeProduct() {
            if(this.threeProductChecked==''){
                this.$toast('请选择三级产品');
                return;
            }
            this.activeIndex2 = this.threeProductList.findIndex(item=> item === this.threeProductChecked);

            this.secondProductList[this.activeIndex1].threeProductList = this.threeProductList;
            this.secondProductList[this.activeIndex1].chooseTp = this.activeIndex2;

              ProductBrands({
                platform:'pcweb',
                ProductId:1812,
              }).then(r=>{
              if(r.Result==1){
                let list=r.Data || [];
                  this.brandList=list.length?list[0].Brands:[];
                  this.filterBrandList=this.brandList;
                  if(list.length){
                    this.showStep=2;
                    this.isCheckAll = false;
                    this.brandChecked = []
                  }else{
                    this.$toast('该产品没有相关品牌');
                  }
              }
            })
        },
        //添加品牌
        confirmBrand(){
            if(this.brandChecked.length==0){
                return;
            }
            let allTagText = this.threeProductList[this.activeIndex2].ProductName + "-"
            this.brandChecked.map(item=>{
                allTagText += item.BrandName + "/"
            })
            let lll = {
                chooseText: allTagText.slice(0,-1),
                chooseList: this.brandChecked,
                id1: this.secondProductList[this.activeIndex1],
                id2: this.threeProductChecked.ProductId,
                id2Name: this.threeProductChecked.ProductName
            };
            let allTag = this.allTag[this.activeIndex1] || [];
            allTag.push(lll)

            this.allTag[this.activeIndex1] = allTag;
            // 提交产品 
            this.onSelectPB();
        },
        onSelectPB() {
          let selectAll = null; //  全选
          let productAndBrandTagList = []; //非全选
            this.allTag.map(item=>{
                item.map(pTag=>{
                  if(pTag.chooseList.length === this.brandList.length) { //全选
                    selectAll = [{
                      threeProductId:  item[0].id2, threeProductName: item[0].id2Name, brandId : 0, brandName: '全部'
                    }]
                  }else {
                    let mm  = pTag.chooseList.map(cTag=>{
                      return { threeProductId:  pTag.id2, threeProductName: pTag.id2Name, brandId : cTag.BrandId, brandName: cTag.BrandName};
                    })
                    productAndBrandTagList = productAndBrandTagList.concat(mm)
                  }
                })
            })
            if(selectAll) {
              productAndBrandTagList = productAndBrandTagList.concat(selectAll)
            }
            console.log("postparams",productAndBrandTagList, selectAll)
          // 提交产品 
          this.$emit("productAndBrandTagList", selectAll ? selectAll : productAndBrandTagList)
          // 数据置空
          this.showStep=false;
          this.resetDialog();
        },
        //搜索品牌
        searchBrand(){
          this.filterBrandList=this.brandList.filter(item=>{
            return item.BrandName.indexOf(this.brandName)!=-1
          })
        },
        //筛选品牌
        filterBrand(key){
          this.letterKey=key;
          if(!key){
            this.filterBrandList=this.brandList;
            return;
          }
          this.filterBrandList=this.brandList.filter(item=>{
            return item.BrandNameFirstLetter==key;
          })
        },
        //全选
        checkAll(){
          for (let i = 0; i < this.$refs.checkbox.length; i++) {
            if(!this.$refs.checkbox[i].checked){
              this.$refs.checkbox[i].click();
            }
          }
          this.isCheckAll=true;
        },
        //取消全选
        checkAllFalse(){
          for (let i = 0; i < this.$refs.checkbox.length; i++) {
            if(this.$refs.checkbox[i].checked){
              this.$refs.checkbox[i].click();
            }
          }
          this.isCheckAll=false;
        },
    }
})
</script>

<style lang="scss">
.certificateTag{
  .label{
    text-align: right;
  }
  .tag-item{
    width: 500px;
    min-height: 38px;
    border: 1px solid #e7e7e7;
    padding: 8px 40px;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    margin-bottom: 10px;
    word-break: break-all;
    position: relative;
    &:hover{
      border-color: #f75959;
      .el-icon-close{
        color: #f75959;
      }
    }
  }
  .el-icon-close{
    font-size: 16px;
    font-weight: bold;
    color: #e7e7e7;
    position: absolute;
    right:0;
    top: 0;
    width: 40px;
    text-align: center;
    cursor: pointer;
    line-height: 38px;
  }
  .btn-add{
    width: 100%;
    height: 38px;
    border: 1px solid #e7e7e7;
    padding: 8px 40px;
    background-color: #fff;
    text-align: center;
    font-size: 14px;
    color: #f75959;
    line-height: 22px;
    cursor: pointer;
    .el-icon-plus{
      margin-right:4px;
      font-weight: bold;
    }
    &:hover{
      border-color: #f75959;
    }
  }
  
  .check-wrapper{
    .btn-primary{
      display: block;
      height: 30px;
      line-height: 30px;
      margin: 20px auto 0;
    }
    .check-list{
      overflow: hidden;
      width: 680px;
      height: 320px;
      overflow-y: auto;
      >li{
        float: left;
        margin-right: 10px;
        margin-bottom: 15px;
        &:nth-child(4n){
          margin-right: 0;
        }
      }
    }
    
  }
  .check-item{
    position: relative;
    display: block;
    .checkbox{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .text{
      display: block;
      padding: 0 10px;
      width: 157px;
      overflow: hidden;
      text-align: center;
      height: 40px;
      border: 1px solid #f9f9f9;
      font-size: 14px;
      color: #333;
      line-height: 38px;
      background-color: #f9f9f9;
      border-radius: 2px;
    }
    .checkbox:checked+.text{
      border-color: #f75959;
    }
  }
  .icon-back{
    position: absolute;
    left: 0px;
    top: 0;
    z-index: 2;
    width: 40px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    cursor: pointer;
    &:before{
      content:'';
      display: inline-block;
      width: 10px;
      height: 10px;
      border-left: 1px solid #fff;
      border-bottom: 1px solid #fff;
      transform: rotate(45deg);
    }
  }
  .search-wrapper{
    overflow: hidden;
    margin-bottom: 6px;
    .btn-check-all{
      float: right;
      font-size: 14px;
      color: #666;
      line-height: 30px;
      background-color: transparent;
      margin-left: 10px;
      cursor: pointer;
      }
  }
  .search-box{
    float: left;
    position: relative;
    input{
      width: 280px;
      border: 1px solid #e5e5e5;
      background: #fff;
      padding-left: 35px;
      border-radius: 30px;
      line-height: 30px;
      height: 30px;
      font-size: 14px;
      font-family: "DIN-Regular";
      color: #666;
    }
    .icon-search{
      position: absolute;
      left: 10px;
      top: 4px;
      line-height: 1;
      font-size:18px;
      color: #f75959;
    }
  }
  .btn-text{
    float: left;
    font-size: 14px;
    color: #f75959;
    line-height: 30px;
    background-color: transparent;
    margin-left: 10px;
    cursor: pointer;
  }
  .letter-list{
    overflow: hidden;
    width: 100%;
    margin-bottom: 6px;
    >li{
      float: left;
      margin-right: 6px;
      padding-left: 4px;
      padding-right: 4px;
      line-height: 24px;
      cursor: pointer;
      font-size: 14px;
      color: #333;
      &.on{
        color: #f75959;
      }
      &:hover{
        color: #f75959;
      }
    }
  }
  .btn-primary{
    width: 100px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin: 20px auto 0;
  }
}
.stages-dialog{
  .domain-wrapper{
    padding: 30px 0 0;
    text-align: center;
    .btn-primary{
      height: 30px;
      line-height: 30px;
      margin: 20px auto 0;
    }
  }
  .domain-item{
    position: relative;
    display: block;
    width: 400px;
    margin: 0 auto 20px;
    .radio{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    .radio-val{
      display: block;
      width: 400px;
      height: 40px;
      border: 1px solid #f9f9f9;
      font-size: 14px;
      color: #333;
      line-height: 38px;
      background-color: #f9f9f9;
      border-radius: 2px;
      word-break: break-all;
      overflow: hidden;
    }
    .radio:checked+.radio-val{
      border-color: #f75959;
    }
  }
}
.stages-dialog {
  .btn-primary {
    margin: 0 auto;
    display: block !important;
  }
}
</style>